<div class="page-layout blank p-24" fusePerfectScrollbar>
    <!-- <h2>{{'SAMPLE.HELLO' | translate}}</h2> -->
    <div class="card table-container">
        <p-table #dt [value]="documents" [scrollable]="true" scrollHeight="calc(100vh - 270px)" [rows]="25"
            [rowsPerPageOptions]="[10,25,50,100]" [paginator]="true"
            [globalFilterFields]="['company.companyName','designation.designationName','documentName','documentPath']"
            styleClass="p-datatable-gridlines" [rowHover]="true" (onFilter)="onFilter($event)">
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">Total {{documents ? documents.length : '' }} Document Vault<span
                            *ngIf="total && total != documents?.length"> (Showing {{total}} Records)</span></h5>
                    <div>
                        <button pButton pRipple icon="pi pi-plus" *ngIf="menuAccess.canAdd"
                            class="p-button-rounded p-button-info p-mr-2 pull-right" pTooltip="Add"
                            tooltipPosition="top" (click)="openNew()"></button>
                        <button pButton pRipple icon="pi pi-file-excel" pTooltip="Export to excel" tooltipPosition="top"
                            (click)="ExportExcel()" class="p-button-rounded p-button-success p-mr-2"></button>
                        <span class="p-input-icon-left pull-right">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="Search..." />
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="company.companyName" *ngIf="companyID">Company Name
                        <p-sortIcon field="company.companyName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="designation.designationName" style="max-width: 300px;">Designation
                        <p-sortIcon field="designation.designationName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="documentName" style="max-width: 400px;">Document Name
                        <p-sortIcon field="documentName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="documentPath"> File Name
                        <p-sortIcon field="documentPath"></p-sortIcon>
                    </th>
                    <th pSortableColumn="isActive" style="max-width: 87px;">Status
                        <p-sortIcon field="isActive"></p-sortIcon>
                    </th>
                    <th style="max-width: 120px;">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-document>
                <tr>
                    <td *ngIf="companyID">{{document.company.companyName}}</td>
                    <td style="max-width: 300px;">{{document.designationId ? document.designation?.designationName :
                        'All'}}</td>
                    <td style="max-width: 400px;">{{document.documentName}}</td>
                    <td style="word-break: normal; overflow-wrap: anywhere;">{{document.documentPath}}</td>

                    <td style="max-width: 87px;">
                        <i class="pi p-button-text " pButton
                            [ngClass]="{'pi-check p-button-success':document.isActive , 'pi-times  p-button-danger': !document.isActive}"
                            [pTooltip]="document.isActive ? 'Active' : 'Inactive'" tooltipPosition="top"></i>
                    </td>
                    <td style="max-width: 120px;">
                        <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                            *ngIf="menuAccess.canEdit" (click)="editDocument(document)" pTooltip="Edit"
                            tooltipPosition="top"></button>
                        <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning p-mr-2"
                            *ngIf="menuAccess.canDelete" (click)="deleteDocument(document)" pTooltip="Delete"
                            tooltipPosition="top"></button>
                        <button (click)="showBasicDialog2(document.documentPath)" type="button" pButton
                            class="p-button-rounded p-button-primary" icon="pi pi-eye"></button>
                    </td>

                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="4">
                        <div class="notFound">
                            Document Vault Data Not found.
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<p-dialog header="Document Vault File" (onShow)="AppendSRC()" class="displayFile" [(visible)]="displayBasic2"
    [style]="{width: '50vw',height: '70vh'}" [baseZIndex]="10000">
    <ng-template pTemplate="header" header="Document Vault File">  
        <div style="display: flex;">
            <p>Document Vault File</p>
            <div style="position: absolute; right: 50px; top: 24px;">
                <button pButton pRipple label="Download" (click)="downloadImg(preview_image)" icon="pi pi-arrow-circle-down"
                    class="p-button-text p-button-danger"></button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div style="text-align:center; ">
            <iframe  id="frame" [src]="" style="width: -webkit-fill-available; height: 500px; "
                class="iframeImage"></iframe>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
         
    </ng-template>
</p-dialog>
<p-dialog [(visible)]="documentDialog" [style]="{width: '450px'}" header="Document Vault Details" [modal]="true"
    styleClass="p-fluid">
    <ng-template pTemplate="content">
        <div style="overflow: auto; overflow-x: hidden; max-height: calc(100vh - 240px);">
            <div class="p-field">
                <label for="designationName">Designation Type</label> <span class="p-pl-1 p-error">*</span>
                <p-dropdown placeholder="Select Designation Type" [(ngModel)]="document.designationId" appendTo="body"
                    [options]="designationsName" optionLabel="designationName" [filter]="true"
                    filterBy="designationName" optionValue="id"></p-dropdown>
                <small class="p-error"
                    *ngIf="submitted && !document.designationId && !document.designation?.departmentName == 'All'">Document
                    Type is required.</small>
            </div>
            <div class="p-field">
                <label for="documentName">Document Name</label><span class="p-pl-1 p-error">*</span>
                <input type="text" pInputText id="documentName" [(ngModel)]="document.documentName" required
                    autofocus />
                <small class="p-error" *ngIf="submitted && !document.documentName">Document Name is required.</small>
            </div>
            <div class="p-field">
                <input type="file" style="display: none;" pInputText (change)="renderImage($event)" id="documentPath"  />
                <button pButton type="button" (click)="UploadImage()" icon="pi pi-plus" label="Upload File"
                    class="p-button-primary"></button>
                <small class="p-error" *ngIf="submitted && (!this.imageBase && !document.id)">Document upload is
                    required.</small>
                <p>{{document.documentPath}}</p>
            </div>
            <div class="p-field">
                <h5 class="p-m-0 p-pb-2" for="isActive">Status</h5>
                <p-inputSwitch id="isActive" name="isActive" [(ngModel)]="document.isActive"></p-inputSwitch>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text p-button-danger"
            (click)="hideDialog()"></button>
        <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text" (click)="saveDocument()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>